import React from "react";
import useHiring, { noticePeriodOptions, statusOptions, technologyOptions } from "./useHiring";
import CommonDataGrid from "../../../components/CommonDataGrid";
import { Column } from "../../../components/CommonDataGrid/props";
import { leadStyes } from "../../../util/constant";
import { useNavigate } from "react-router-dom";
import { AddButton } from "../../../components/Button";
import EditImg from "../../../images/SideBar/Edit";
// import ViewImg from "../../../images/SideBar/View";
import Modal from "../../../components/Model";
import ViewImg from "../../../images/SideBar/View";
import toast from "react-hot-toast";
import { Trash } from "lucide-react";

const Hiring = () => {
  const {
    allhired,
    page,
    totalPage,
    getAllHired,
    setSearch,
    setPage,
    handleStatusChange,
    handleSelectStatus,
    handleAddHrNote,
    handleAddRaviNote,
    handleEdit,
    noticePeriodFilter,
    setNoticePeriodFilter,
    statusFilter,
    setStatusFilter,
    technologyFilter,
    setTechnologyFilter,
    handleDelete
  } = useHiring();

  const StatusFilter = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef<HTMLDivElement>(null);
    const dropdownMenuRef = React.useRef<HTMLDivElement>(null);
    const [dropdownPosition, setDropdownPosition] = React.useState({ top: 0, left: 0 });

    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as Node;
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(target) &&
          dropdownMenuRef.current &&
          !dropdownMenuRef.current.contains(target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    React.useEffect(() => {
      if (isOpen && dropdownRef.current) {
        const rect = dropdownRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + 4,
          left: rect.left + (rect.width / 2)
        });
      }
    }, [isOpen]);

    const selectedOption = statusOptions.find(
      (opt) => opt.id === statusFilter
    ) || statusOptions[0];

    const handleSelectOption = (optionId: string) => {
      console.log("Status filter selected:", optionId);
      setStatusFilter(optionId);
      setIsOpen(false);
    };

    return (
      <>
        <div className="relative flex items-center justify-center gap-1 w-full cursor-pointer" ref={dropdownRef}>
          <span className="text-xs font-normal whitespace-nowrap">STATUS</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            className="flex items-center justify-center p-0 m-0 bg-transparent border-0 outline-none focus:outline-none"
          >
            <svg
              className={`w-4 h-4 text-gray-500 transition-transform ${
                isOpen ? "transform rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
        {isOpen && (
          <div 
            ref={dropdownMenuRef}
            className="fixed bg-white border border-gray-300 rounded-md shadow-lg min-w-[140px] max-h-60 overflow-y-auto z-[10000]"
            style={{
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              transform: 'translateX(-50%)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ul className="py-1">
              {statusOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleSelectOption(option.id)}
                  className={`px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 ${
                    statusFilter === option.id
                      ? "bg-blue-50 text-blue-600 font-medium"
                      : "text-fontColor"
                  }`}
                >
                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  const NoticePeriodFilter = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef<HTMLDivElement>(null);
    const dropdownMenuRef = React.useRef<HTMLDivElement>(null);
    const [dropdownPosition, setDropdownPosition] = React.useState({ top: 0, left: 0 });

    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as Node;
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(target) &&
          dropdownMenuRef.current &&
          !dropdownMenuRef.current.contains(target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    React.useEffect(() => {
      if (isOpen && dropdownRef.current) {
        const rect = dropdownRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + 4,
          left: rect.left + (rect.width / 2)
        });
      }
    }, [isOpen]);

    const selectedOption = noticePeriodOptions.find(
      (opt) => opt.id === noticePeriodFilter
    ) || noticePeriodOptions[0];

    const handleSelectOption = (optionId: string) => {
      console.log("Notice Period filter selected:", optionId);
      setNoticePeriodFilter(optionId);
      setIsOpen(false);
    };

    return (
      <>
        <div className="relative flex items-center justify-center gap-1 w-full cursor-pointer" ref={dropdownRef}>
          <span className="text-xs font-normal whitespace-nowrap">NOTICE PERIOD</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            className="flex items-center justify-center p-0 m-0 bg-transparent border-0 outline-none focus:outline-none"
          >
            <svg
              className={`w-4 h-4 text-gray-500 transition-transform ${
                isOpen ? "transform rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
        {isOpen && (
          <div 
            ref={dropdownMenuRef}
            className="fixed bg-white border border-gray-300 rounded-md shadow-lg min-w-[140px] max-h-60 overflow-y-auto z-[10000]"
            style={{
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              transform: 'translateX(-50%)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ul className="py-1">
              {noticePeriodOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleSelectOption(option.id)}
                  className={`px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 ${
                    noticePeriodFilter === option.id
                      ? "bg-blue-50 text-blue-600 font-medium"
                      : "text-fontColor"
                  }`}
                >
                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  const TechnologyFilter = () => {
    const [isOpen, setIsOpen] = React.useState(false);
    const dropdownRef = React.useRef<HTMLDivElement>(null);
    const dropdownMenuRef = React.useRef<HTMLDivElement>(null);
    const [dropdownPosition, setDropdownPosition] = React.useState({ top: 0, left: 0 });

    React.useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as Node;
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(target) &&
          dropdownMenuRef.current &&
          !dropdownMenuRef.current.contains(target)
        ) {
          setIsOpen(false);
        }
      };

      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    React.useEffect(() => {
      if (isOpen && dropdownRef.current) {
        const rect = dropdownRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom + 4,
          left: rect.left + (rect.width / 2)
        });
      }
    }, [isOpen]);

    const selectedOption = technologyOptions.find(
      (opt) => opt.id === technologyFilter
    ) || technologyOptions[0];

    const handleSelectOption = (optionId: string) => {
      console.log("Technology filter selected:", optionId);
      setTechnologyFilter(optionId);
      setIsOpen(false);
    };

    return (
      <>
        <div className="relative flex items-center justify-center gap-1 w-full cursor-pointer" ref={dropdownRef}>
          <span className="text-xs font-normal whitespace-nowrap">TECHNOLOGY</span>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(!isOpen);
            }}
            className="flex items-center justify-center p-0 m-0 bg-transparent border-0 outline-none focus:outline-none"
          >
            <svg
              className={`w-4 h-4 text-gray-500 transition-transform ${
                isOpen ? "transform rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
        {isOpen && (
          <div 
            ref={dropdownMenuRef}
            className="fixed bg-white border border-gray-300 rounded-md shadow-lg min-w-[140px] max-h-60 overflow-y-auto z-[10000]"
            style={{
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`,
              transform: 'translateX(-50%)',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <ul className="py-1">
              {technologyOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleSelectOption(option.id)}
                  className={`px-3 py-2 text-xs cursor-pointer hover:bg-gray-100 ${
                    technologyFilter === option.id
                      ? "bg-blue-50 text-blue-600 font-medium"
                      : "text-fontColor"
                  }`}
                >
                  {option.name}
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  const [isHrNoteModalOpen, setIsHrNoteModalOpen] = React.useState(false);
  const [selectedHrNote, setSelectedHrNote] = React.useState<string>("");
  const [selectedRejectionNote, setSelectedRejectionNote] = React.useState<string>("");
  const [selectedRaviNote, setSelectedRaviNote] = React.useState<string>("");
  const [isRejectionNoteModalOpen, setIsRejectionNoteModalOpen] = React.useState(false);
  const [rejectionNote, setRejectionNote] = React.useState<string>("");
  const [isAddNoteModalOpen, setIsAddNoteModalOpen] = React.useState(false);
  const [newHrNote, setNewHrNote] = React.useState<string>("");
  const [newRaviNote, setNewRaviNote] = React.useState<string>("");
  const [selectedHiringId, setSelectedHiringId] = React.useState<string>("");
  const [existingHrNote, setExistingHrNote] = React.useState<string>("");
  const [existingRaviNote, setExistingRaviNote] = React.useState<string>("");
  const [pendingStatusChange, setPendingStatusChange] = React.useState<{
    event: any;
    params: any;
  } | null>(null);

  const handleViewHrNote = (hrNote: string, rejectionNote?: string, raviNote?: string) => {
    // Store all notes separately
    setSelectedHrNote(hrNote || "");
    setSelectedRejectionNote(rejectionNote || "");
    setSelectedRaviNote(raviNote || "");
    setIsHrNoteModalOpen(true);
  };

  const handleCloseHrNoteModal = () => {
    setIsHrNoteModalOpen(false);
    setSelectedHrNote("");
    setSelectedRejectionNote("");
    setSelectedRaviNote("");
  };

  const parseNotes = (notes: string): Array<{ timestamp: string; message: string }> => {
    if (!notes) return [];
    
    const parsedNotes: Array<{ timestamp: string; message: string }> = [];
    
    const notePattern = /^\[(.+?)\]\s*(.+)$/m;
    const allLines = notes.split('\n');
    
    let currentNote: { timestamp: string; message: string } | null = null;
    
    allLines.forEach((line, index) => {
      const match = line.match(/^\[(.+?)\]\s*(.+)$/);
      
      if (match) {
        if (currentNote) {
          parsedNotes.push(currentNote);
        }
        currentNote = {
          timestamp: match[1],
          message: match[2] 
        };
      } else if (currentNote) {
        currentNote.message += '\n' + line;
      } else {
        if (line.trim() !== '') {
          parsedNotes.push({
            timestamp: '',
            message: line
          });
        }
      }
    });
    
    if (currentNote) {
      parsedNotes.push(currentNote);
    }
    
    return parsedNotes;
  };

  // Render notes in chat-like format
  const renderChatNotes = (notes: string, bgColor: string, borderColor: string) => {
    const parsedNotes = parseNotes(notes);
    
    if (parsedNotes.length === 0) return null;
    
    const reversedNotes = [...parsedNotes].reverse();
    
    return (
      <div className="space-y-2 max-h-64 md:max-h-96 overflow-y-auto overflow-x-hidden">
        {reversedNotes.map((note, index) => (
          <div
            key={index}
            className={`${bgColor} ${borderColor} border rounded-lg p-2 md:p-3 shadow-sm break-words overflow-x-hidden w-full`}
          >
            {note.timestamp && (
              <div className="text-xs md:text-sm text-gray-500 mb-1 font-medium break-words overflow-x-hidden">
                {note.timestamp}
              </div>
            )}
            <div className="text-sm md:text-base text-gray-700 whitespace-pre-wrap break-words overflow-x-hidden w-full">
              {note.message}
            </div>
          </div>
        ))}
      </div>
    );
  };

  const handleStatusChangeWithRejectionNote = (e: any, params: any) => {
    const newStatus = e.target.value;
    if (newStatus === "HR Rejection" || newStatus === "Rejection") {
      setPendingStatusChange({ event: e, params });
      setIsRejectionNoteModalOpen(true);
      setRejectionNote("");
    } else {
      handleStatusChange(e, params);
    }
  };

  const handleRejectionNoteSubmit = () => {
    if (pendingStatusChange && handleSelectStatus) {
       handleSelectStatus(
        pendingStatusChange.event,
        pendingStatusChange.params.row,
        rejectionNote
      );
      setIsRejectionNoteModalOpen(false);
      setRejectionNote("");
      setPendingStatusChange(null);
    }
  };

  const handleRejectionNoteCancel = () => {
   
    if (pendingStatusChange) {
      const selectElement = pendingStatusChange.event.target;
      selectElement.value = pendingStatusChange.params.value;
    }
    setIsRejectionNoteModalOpen(false);
    setRejectionNote("");
    setPendingStatusChange(null);
  };

  const handleOpenAddNoteModal = (hiringId: string, existingHrNote?: string, existingRaviNote?: string) => {
    setSelectedHiringId(hiringId);
    setNewHrNote("");
    setNewRaviNote("");
    setExistingHrNote(existingHrNote || "");
    setExistingRaviNote(existingRaviNote || "");
    setIsAddNoteModalOpen(true);
  };

  const handleCloseAddNoteModal = () => {
    setIsAddNoteModalOpen(false);
    setNewHrNote("");
    setNewRaviNote("");
    setSelectedHiringId("");
    setExistingHrNote("");
    setExistingRaviNote("");
  };

  const handleAddNoteSubmit = async () => {
    if (!selectedHiringId) return;
    
    let hasNotes = false;
    
    if (newHrNote && newHrNote.trim() && handleAddHrNote) {
      await handleAddHrNote(selectedHiringId, newHrNote, existingHrNote);
      hasNotes = true;
    }
    if (newRaviNote && newRaviNote.trim() && handleAddRaviNote) {
      await handleAddRaviNote(selectedHiringId, newRaviNote, existingRaviNote);
      hasNotes = true;
    }
    
    if (!hasNotes) {
      toast.error("Please enter at least one note");
      return;
    }
    
    handleCloseAddNoteModal();
  };

  const columns: Column[] = [
    {
      field: "name",
      headerName: "Name",
      renderCell: (params: any) =>{
        return (
          <a href={params.row.linkedInId} target="_blank" rel="noopener noreferrer" className={`${params.row.linkedInId? " text-blue-500 border-b-2 border-blue-500" : "text-gray-500"}`}>{params.row.name}</a>
        )
      },
      width: 25,
      align: "center",
    },
    {
      field: "experienceTech",
      headerName: "Technology",
      width: 25,
      align: "center",
      renderHeader: () => <TechnologyFilter />,
    },
    {
      field: "currentCTC",
      headerName: "Current CTC",
      width: 25,
      align: "center",
    },
    {
      field: "expectedCTC",
      headerName: "Expected CTC",
      width: 25,
      align: "center",
    },
    {
      field: "noticePeriod",
      headerName: "Notice Period",
      width: 25,
      align: "center",
      renderHeader: () => <NoticePeriodFilter />,
    },
    {
      field: "experience",
      headerName: "Experience",
      width: 25,
      align: "center",
    },
    {
      field: "lastIncrement",
      headerName: "Last Increment",
      width: 25,
      align: "center",
    },
    {
      field: "salaryBeforeLastIncrement",
      headerName: "SBL Increment",
      width: 25,
      align: "center",
    },
    {
      field: "resume",
      headerName: "Resume",
      renderCell: (params: any) => (
        <a
          href={params.value}
          target="_blank"
          className="text-blue-500 border-b-2 border-b-blue-500 "
        >
          Resume
        </a>
      ),
      width: 25,
      align: "center",
    },
    {
      field: "status",
      headerName: "Status",
      renderHeader: () => <StatusFilter />,
      renderCell: (params: any) => (
        <>
          <div
            className={`${leadStyes[params.value] || "bg-gray-200 "} min-w-24`}
          >
            <select
              defaultValue={params.value}
              onChange={(event) => handleStatusChangeWithRejectionNote(event, params)}
              className="appearance-none  bg-transparent outline-none w-full cursor-pointer font-semibold"
            >
              <option value="Follow-Up">Follow-Up</option>
              <option value="Hold">Hold</option>
              <option value="Schedule">Schedule</option>
              <option value="Rejection">Rejection</option>
              <option value="High Salary">High Salary</option>
              <option value="HR Rejection">HR Rejection</option>
              <option value="HR Action">HR Action</option>
              <option value="TL Action">TL Action</option>
              <option value="Call NA">Call NA</option>
              <option value="Practical Needed">Practical Needed</option>
            </select>
          </div>
        </>
      ),
      width: 25,
      align: "center",
    },
    {
      field: "hrNote",
      headerName: "Notes",
      renderCell: (params: any) => {
        return (
          <button
            onClick={() => handleViewHrNote(
              params.value, 
              params.row.rejectionNote, 
              params.row.raviNote
            )}
            className="cursor-pointer hover:opacity-70"
            title="View Notes"
          >
            <ViewImg />
          </button>
        );
      },
      width: 25,
      align: "center",
    },
    {
      field: "addNote",
      headerName: "Add Note",
      renderCell: (params: any) => {
        return (
          <button
            onClick={() => handleOpenAddNoteModal(params.row._id, params.row.hrNote, params.row.raviNote)}
            className="px-2 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition-colors"
            title="Add Note"
          >
            + Add
          </button>
        );
      },
      width: 25,
      align: "center",
    },
    {
      field: "",
      headerName: "Actions",
      renderCell: (params: any) => (
        <div className="flex gap-2">

        <button onClick={() => handleEdit(params.row._id)}>
          <EditImg />
        </button>
        <button onClick={() => handleDelete(params.row._id)} >
          <Trash color="red" />
        </button>
        </div>
      ),
      width: 25,
      align: "center",
    },
  ];
  const navigate = useNavigate();

  const handleAdd = () => {
    navigate("/addHiring");
  };

  return (
    <div className="m-10 ">
      <div className="w-full flex justify-end items-center mb-4">
        <AddButton type="button" onClick={handleAdd} className="">
          +
        </AddButton>
      </div>
      <CommonDataGrid
        tableName="Hiring Data"
        rows={allhired}
        columns={columns}
        getRowId={(row) => row._id}
        showConfirmation={false}
        confirmationMessage="Are you sure want to make a client?"
        onCancelDelete={() => {}}
        onConfirmDelete={() => {}}
        loading={!allhired}
        onDateFilter={getAllHired}
        addButton
        setSearchBar={setSearch}
        setCurrentPage={setPage}
        currentPage={page}
        totalPages={totalPage}
        downloadCSVFilter={false}
        defaultDateNumber="1"
      />
      {/* HR Note Modal */}
      <Modal
        isOpen={isHrNoteModalOpen}
        onClose={handleCloseHrNoteModal}
        style="w-full max-w-4xl max-h-[90vh] overflow-y-auto overflow-x-hidden mx-4"
      >
        <div className="mb-4 p-4 md:p-6 w-full overflow-x-hidden">
          <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-4">Notes</h3>
          <div className="flex flex-col md:flex-row md:justify-between gap-4 md:gap-6 w-full overflow-x-hidden">
            {/* Rejection Note Section */}
            {selectedRejectionNote && (
              <div className="mb-4 md:mb-6 flex-1 min-w-0">
                <h4 className="text-sm md:text-md font-semibold text-gray-800 mb-3 flex items-center">
                  <span className="w-2 h-2 bg-red-500 rounded-full mr-2 flex-shrink-0"></span>
                  Rejection Note
                </h4>
                {renderChatNotes(selectedRejectionNote, "bg-red-50", "border-red-200")}
              </div>
            )}
            
            {/* HR Note Section */}
            {selectedHrNote && (
              <div className="mb-4 md:mb-6 flex-1 min-w-0">
                <h4 className="text-sm md:text-md font-semibold text-gray-800 mb-3 flex items-center">
                  <span className="w-2 h-2 bg-blue-500 rounded-full mr-2 flex-shrink-0"></span>
                  HR Note
                </h4>
                {renderChatNotes(selectedHrNote, "bg-blue-50", "border-blue-200")}
              </div>
            )}
            
            {/* Ravi Note Section */}
            {selectedRaviNote && (
              <div className="mb-4 md:mb-6 flex-1 min-w-0">
                <h4 className="text-sm md:text-md font-semibold text-gray-800 mb-3 flex items-center">
                  <span className="w-2 h-2 bg-green-500 rounded-full mr-2 flex-shrink-0"></span>
                  Ravi Note
                </h4>
                {renderChatNotes(selectedRaviNote, "bg-green-50", "border-green-200")}
              </div>
            )}
            
            {/* No Notes Message */}
            {!selectedRejectionNote && !selectedHrNote && !selectedRaviNote && (
              <div className="text-gray-500 italic text-center py-8">No notes available</div>
            )}
          </div>
        </div>
      </Modal>

      {/* Rejection Note Modal */}
      <Modal
        isOpen={isRejectionNoteModalOpen}
        onClose={handleRejectionNoteCancel}
        style="w-full max-w-2xl max-h-[90vh] overflow-y-auto"
      >
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Add {pendingStatusChange?.event?.target?.value === "HR Rejection" ? "HR " : ""}Rejection Note
          </h3>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rejection Note:
            </label>
            <textarea
              className="w-full p-3 mr-3 border border-gray-300 rounded-md "
              rows={6}
              minLength={30}
              value={rejectionNote}
              onChange={(e) => setRejectionNote(e.target.value)}
              placeholder="Enter rejection note (will be added to existing notes)..."
            />
            {rejectionNote.length < 30 && (
              <div className="text-red-500 text-sm mt-1">
                Rejection note must be at least 30 characters long
              </div>
            )}
          </div>
          
          <div className="flex justify-end gap-2 mt-4">
            <button
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-100"
              onClick={handleRejectionNoteCancel}
            >
              Cancel
            </button>
            <button
               className={`px-4 py-2 text-white rounded 
                ${rejectionNote.length >= 30 ? "bg-blue-600 hover:bg-blue-700" : "bg-blue-400 cursor-not-allowed"}`}
              onClick={handleRejectionNoteSubmit}
              disabled={rejectionNote.length < 30}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>

      {/* Add Note Modal */}
      <Modal
        isOpen={isAddNoteModalOpen}
        onClose={handleCloseAddNoteModal}
        style="w-full max-w-2xl max-h-[90vh] overflow-y-auto overflow-x-hidden"
      >
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Add Note</h3>
          
          {/* HR Note Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              HR Note:
            </label>
            <textarea
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              rows={4}
              value={newHrNote}
              onChange={(e) => setNewHrNote(e.target.value)}
              placeholder="Enter HR note (will be added to existing notes)..."
            />
          </div>

          {/* Ravi Note Field */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Ravi Note:
            </label>
            <textarea
              className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              rows={4}
              value={newRaviNote}
              onChange={(e) => setNewRaviNote(e.target.value)}
              placeholder="Enter Ravi note (will be added to existing notes)..."
            />
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-100"
              onClick={handleCloseAddNoteModal}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
              onClick={handleAddNoteSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Hiring;
